{
  "id": "cotton",
  "name": "Upland cotton",
  "species": "Gossypium hirsutum",
  "ploidy": 4,
  "assembly": "TM-1 UTX v2.1",
  "chromosomes": [
    "A01",
    "A02",
    "A03",
    "A04",
    "A05",
    "A06",
    "A07",
    "A08",
    "A09",
    "A10",
    "A11",
    "A12",
    "A13",
    "D01",
    "D02",
    "D03",
    "D04",
    "D05",
    "D06",
    "D07",
    "D08",
    "D09",
    "D10",
    "D11",
    "D12",
    "D13"
  ],
  "keys": [
    "A1",
    "A2",
    "A3",
    "A4",
    "A5",
    "A6",
    "A7",
    "A8",
    "A9",
    "A10",
    "A11",
    "A12",
    "A13",
    "D1",
    "D2",
    "D3",
    "D4",
    "D5",
    "D6",
    "D7",
    "D8",
    "D9",
    "D10",
    "D11",
    "D12",
    "D13"
  ],
  "pattern": "^(?:chr|chromosome)?[_\\s-]?([AD])[_-]?0*([1-9]|1[0-3])$",
  "sources": [
    "https://ftp.ncbi.nlm.nih.gov/genomes/all/GCF/007/990/345/GCF_007990345.1_Gossypium_hirsutum_v2.1/GCF_007990345.1_Gossypium_hirsutum_v2.1_assembly_report.txt"
  ]
}
